import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class PermissaoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let permissao = model;
        
        // Não se usa mais permissão por módulo nessa tela
        // if ( !permissao.permiteagro && !permissao.permitevendas && !permissao.permitepromotor ) {
        //     validated = false;
        // }
        if ( !validated ){
            this.showMessage(new Message('alert', 'msg-necessario-permissao', true));
        }
        
        return validated;
    }

}